"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const DetailTitle_vue_1 = __importDefault(require("@/pages/index/components/DetailTitle.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'HomeAnalysisTable',
    components: {
        DetailTitle: DetailTitle_vue_1.default
    },
    props: {
        title: {
            type: String,
            required: true
        },
        width: {
            type: Number,
            required: true
        },
        api: {
            type: Object,
            required: true
        },
        params: {
            type: Object,
            required: false
        },
        columns: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            list: []
        };
    },
    watch: {
        api() {
            this.loadData();
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.api.require(this.params).then(res => {
                this.list = res.data.data;
            });
        }
    }
});
